import { Layout, theme } from "antd";
import React, { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Route, Routes } from "react-router-dom";
import Error404 from "../pages/errors/Error404";
import Menu from "./Menu";
import MobileMenuDrawer from "./MobileMenuDrawer";
import Top from "./Top";
import routes, { AppRoute } from "./routes";
import AdminProfile from "../pages/Profile";
import SidebarMenu from "./SidebarMenu";
import { Link } from "react-router-dom";

const newRoutes: AppRoute[] = [];

function convertMultiToSingle(arr: AppRoute[], prevBaseUrl: string = ""): void {
  arr.forEach((v) => {
    if (v.children) {
      convertMultiToSingle(v.children, prevBaseUrl + v.url);
    } else if (!v.ignore) {
      newRoutes.push({ ...v, url: prevBaseUrl + v.url });
    }
  });
}

convertMultiToSingle([...routes]);

const MyLayout: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const showDrawer = () => {
    setOpen(true);
  };

  return (
    <>
      <Layout className="min-h-screen bg-white">
        <Layout.Sider
          collapsible
          width={340}
          collapsed={collapsed}
          trigger={null}
          className="bg-primary  rounded-r-3xl lg:block hidden"
        >
          <div
            className={`p-4 pt-6 flex items-center justify-center mb-2  max-h-[80px] border-b border-primary ${
              collapsed ? "justify-center" : "justify-start"
            }`}
          >
            <Link to="/">
              <img
                src="/new-img/newLogo.png"
                alt="Logo"
                className={`w-full  h-20 object-contain`}
              />
            </Link>
          </div>
          {/* <Menu /> */}
          <SidebarMenu collapsed={collapsed} />
        </Layout.Sider>
        <MobileMenuDrawer open={open} setOpen={setOpen} />

        <Layout className="bg-white">
          <Top {...{ collapsed, setCollapsed, showDrawer }} />
          <Layout.Content className="p-3  sm:p-5 text-black overflow-auto h-20">
            <Routes>
              {newRoutes.map((v) =>
                v.component && v.url ? (
                  <Route
                    path={v.url}
                    key={v.url}
                    element={React.createElement(v.component)}
                  />
                ) : null,
              )}

              <Route path={"*"} element={<Error404 />} />
              <Route path={"/profile"} element={<AdminProfile />} />
            </Routes>
          </Layout.Content>
        </Layout>
      </Layout>
    </>
  );
};

export default MyLayout;
